module.exports = __webpack_public_path__ + "img/Cieslik.9217bfc8.jpg";